import { render, staticRenderFns } from "./CountryOverviewDetailsMonthsTable.vue?vue&type=template&id=04bb6f0c&"
import script from "./CountryOverviewDetailsMonthsTable.vue?vue&type=script&lang=js&"
export * from "./CountryOverviewDetailsMonthsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports